export const sources = {
	webp: "__VITE_ASSET__gOpBNSELCNdnM_yZlyA5OQ__ 400w, __VITE_ASSET__ZoP2ebLT5e$hm8jPkF9mgA__ 800w"
};
export const img = {
	src: "__VITE_ASSET__ZoP2ebLT5e$hm8jPkF9mgA__",
	w: 800,
	h: 1067
};
export default {
	sources: sources,
	img: img
};
